import { generateActions } from "../generateActions";
import { eThongKeCRMActionDefine } from './../../action-types/thong-ke/IThongKeCRMActions';

export const thongKeCRMActions = {
    ...generateActions(eThongKeCRMActionDefine, "THONG_KE_CRM"),
}